// Больше двух знаков в бейдж счётчика не влезает — тот же формат, что и в
// серверной разметке шапки (include/header.php).
function formatCounterValue(count) {
    return Number(count) > 99 ? '99+' : count;
}

function productCompare() {
    if (!document.querySelector('.js-product-compare')) return;

    const compCount = document.querySelector('.js-compare-count');
    const compCountWrap = document.querySelector('.js-compare-count-wrap');

    document.addEventListener('click', async (e) => {
        const target = e.target.closest('.js-product-compare');

        if (!target) return;

        e.preventDefault();

        const card = target.closest('.product-card') || target.closest('.js-product-to-cart-btn');

        const isCompare = card.classList.contains('_compare');
        const isAuth = (window.userId || 0) > 0;
        const isComparePage = window.location.pathname === '/cabinet/compare/';

        const id = target.dataset.productId;
        const url = isCompare ? APP.DELETE_COMPARE_URL : APP.ADD_COMPARE_URL;

        try {
            const formData = new FormData();
            formData.append('id', id);

            const res = await fetch(url, {
                method: 'POST',
                body: formData
            });

            const data = await res.json();

            if (res.ok) {
                if (res.status === 200 && data.status === 'success' && data.data.result) {
                    if (isCompare) {
                        card.classList.remove('_compare');
                    } else {
                        card.classList.add('_compare');

                        if (/*!isAuth &&*/ !isComparePage) {
                            modals.openModal(null, '#adds-to-compare');
                        }
                    }

                    if (isComparePage) {
                        if ((document.querySelector('.lk__comparison-item._active .swiper-wrapper').childElementCount > 1) && (document.querySelector(".lk__comparison-category").childElementCount > 1)) {
                            window.location.href = '?section=' + document.querySelector('.lk__comparison-categoryItem._active').dataset.comparison;
                        } else {
                            window.location.href = '/cabinet/compare/';
                        }
                    }

                    compCount.textContent = formatCounterValue(data.data.count);
                    compCountWrap.style.display = 'flex';
                }
            }
        } catch (e) {
            switch (window.lang) {
                case 'en': {
                    modalMessage('An error has occurred');

                    break;
                }
                default: {
                    modalMessage('Произошла ошибка');
                }
            }
        }
    })
}

function productFavorite() {
    if (!document.querySelector('.js-product-favorite')) return;

    const favCount = document.querySelector('.js-favorite-count');
    const favCountWrap = document.querySelector('.js-favorite-count-wrap');

    document.addEventListener('click', async (e) => {
        const target = e.target.closest('.js-product-favorite');

        if (!target) return;

        e.preventDefault();

        const card = target.closest('.product-card') || target.closest('.js-product-to-cart-btn');

        const isFav = card.classList.contains('_favorite');
        const isAuth = (window.userId || 0) > 0;
        const isFavoritePage = window.location.pathname === '/cabinet/favorite/';

        const id = target.dataset.productId;
        const url = isFav ? APP.DELETE_FAVORITE_URL : APP.ADD_FAVORITE_URL;

        /*if (!isAuth) {
            modals.openModal(null, '#lk-auth');
            return;
        }*/

        try {
            const formData = new FormData();
            formData.append('id', id);

            const res = await fetch(url, {
                method: 'POST',
                body: formData
            });

            const data = await res.json();

            if (res.ok) {
                if (res.status === 200 && data.status === 'success' && data.data.result) {
                    if (isFav) {
                        card.classList.remove('_favorite');
                    } else {
                        card.classList.add('_favorite');

                        if (!isFavoritePage) {
                            modals.openModal(null, '#adds-to-favorite');
                        }
                    }

                    favCount.textContent = formatCounterValue(data.data.count);
                    favCountWrap.style.display = 'flex';
                }
            }
        } catch (e) {
            switch (window.lang) {
                case 'en': {
                    modalMessage('An error has occurred');

                    break;
                }
                default: {
                    modalMessage('Произошла ошибка');
                }
            }
        }
    })
}
